import { Injectable } from '@angular/core';
import { RestService } from '../rest.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ErrorsService, CARREGAR, SALVAR, ATUALIZAR, ENVIAR } from '../errors/errors.service';
import { URL_API } from 'src/app/tools/URL';
import { retry, catchError } from 'rxjs/operators';
import { LgpdVO } from 'src/app/entity/LgpdVO';
import { AuthService } from '../autenticacao/auth.service';
import { MSG_OBG_DATA_NASCIMENTO, MSG_OBG_DOCUMENTO_LEGAL_ANEXO, MSG_OBG_FOTO_REQUERENTE_ANEXO, MSG_OBG_IDENTIFICACAO_TITULAR_ANEXO } from 'src/app/tools/Mensagens';

@Injectable({
  providedIn: 'root'
})
export class LgpdService {
  lgpd = this.builder.group(this.preencherVo());
  anexosPreenchidos: boolean = false;

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_LGPD}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      if (retorno.id) {
        this.lgpd.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
        this.lgpd.controls.assuntos.setValue(retorno.assuntos);
      }
    });

  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_LGPD + '/' + id}`);

  }

  gravarManifestoOperador(manifestante, arquivos = [], titularDados, representanteLegal, isEnviar) {

    this.lgpd.controls.nome.setValue(manifestante.nome);
    this.lgpd.controls.email.setValue(manifestante.email);
    this.lgpd.controls.username.setValue(this.authService.usuarioLogado.username);

    this.lgpd.controls.files.setValue([]);
    this.lgpd.controls.identificacaoTitular.setValue([]);
    this.lgpd.controls.fotoRequerente.setValue([]);
    this.lgpd.controls.documentoLegal.setValue([]);

    // Valida se a data de nascimento foi preenchida
    this.validarDataNascimento(this.lgpd.controls.dataNascimento.value)

    // Se o requerente for o titular, são obrigatórios os anexos de doc. de identificação e foto
    if (this.lgpd.controls.requerente.value === 'Titular dos Dados') {
      this.preencherAnexosTitular(titularDados);
      this.anexosPreenchidos = this.validarAnexos(2)
    }
    // Se o requerente for um representante legal, todos os anexos são obrigatórios (identificação, foto, procuração)
    else if (this.lgpd.controls.requerente.value === 'Representante Legal') {
      this.validarDataNascimento(this.lgpd.controls.representanteLegal.get('dataNascimento').value)
      this.preencherAnexosRepresentanteLegal(representanteLegal);
      this.anexosPreenchidos = this.validarAnexos(3)
    }

    arquivos.forEach((value, key) => {
      this.lgpd.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    if(!this.anexosPreenchidos) {
      alert("Formulário não está válido. Os anexos do requerente são obrigatórios.");
    }
    else {
      return isEnviar ? this.enviar(this.lgpd.value) : this.salvar(this.lgpd.value);
    }

  }

  validarDataNascimento(dataNascimento) {
    if (!dataNascimento) {
      alert(MSG_OBG_DATA_NASCIMENTO)
    }
  }

  public validarAnexos(anexosObrigatorios: number): boolean {
    if (this.lgpd.value.identificacaoTitular.length == 0) {
      alert(MSG_OBG_IDENTIFICACAO_TITULAR_ANEXO)
      return false;
    }

    else if (this.lgpd.value.fotoRequerente.length == 0) {
      alert(MSG_OBG_FOTO_REQUERENTE_ANEXO)
      return
    }

    else if (anexosObrigatorios == 3 && this.lgpd.value.documentoLegal.length == 0) {
      alert(MSG_OBG_DOCUMENTO_LEGAL_ANEXO)
      return false;
    }

    else {
      return true; // Todos os anexos estão preenchidos
    }
  }

  preencherAnexosTitular(titularDados: any) {
    titularDados.identificacaoTitular.mapFilesBase64.forEach((value, key) => {
      var nomeArquivoComTag = key;
      if (!String(key).includes("(RGT)")) {
        nomeArquivoComTag = String(key).replace(".", " (RGT).");
      }
      this.lgpd.value.identificacaoTitular.push({
        nomeArquivo: nomeArquivoComTag,
        conteudo: value
      });
    });

    titularDados.fotoRequerente.mapFilesBase64.forEach((value, key) => {
      var nomeArquivoComTag = key;
      if (!String(key).includes("(CRGT)")) {
        nomeArquivoComTag = String(key).replace(".", " (CRGT).");
      }
      this.lgpd.value.fotoRequerente.push({
        nomeArquivo: nomeArquivoComTag,
        conteudo: value
      });
    });
  }

  preencherAnexosRepresentanteLegal(representanteLegal: any) {

    representanteLegal.identificacaoTitular.mapFilesBase64.forEach((value, key) => {
      var nomeArquivoComTag = key;
      if (!String(key).includes("(RGR)")) {
        nomeArquivoComTag = String(key).replace(".", " (RGR).");
      }
      this.lgpd.value.identificacaoTitular.push({
        nomeArquivo: nomeArquivoComTag,
        conteudo: value
      });
    });

    representanteLegal.fotoRequerente.mapFilesBase64.forEach((value, key) => {
      var nomeArquivoComTag = key;
      if (!String(key).includes("(CRGR)")) {
        nomeArquivoComTag = String(key).replace(".", " (CRGR).");
      }
      this.lgpd.value.fotoRequerente.push({
        nomeArquivo: nomeArquivoComTag,
        conteudo: value
      });
    });

    representanteLegal.documentoLegal.mapFilesBase64.forEach((value, key) => {
      var nomeArquivoComTag = key;
      if (!String(key).includes("(PR)")) {
        nomeArquivoComTag = String(key).replace(".", " (PR).");
      }
      this.lgpd.value.documentoLegal.push({
        nomeArquivo: nomeArquivoComTag,
        conteudo: value
      });
    });
  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  public enviar(obj: LgpdVO) {
    return this.rest.post(`${URL_API.PATH_LGPD}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  private gravar(obj: LgpdVO) {
    return this.rest.post(`${URL_API.PATH_LGPD}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  private atualizar(obj) {
    return this.rest.put(`${URL_API.PATH_LGPD}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  validarProcesso(numeroProcessoSEI: string) {
    return this.rest.get(`${URL_API.PATH_LGPD}/processoSEI/${numeroProcessoSEI}`);
  }

  preencherVo() {
    return {
      id: null,
      files: null,
      identificacaoTitular: null,
      fotoRequerente: null,
      documentoLegal: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      nome: new FormControl({ value: null }, [Validators.required]),
      emailRetorno: new FormControl(null),
      email: new FormControl({ value: null }, [Validators.required]),
      cpf: new FormControl({ value: null }, [Validators.required, Validators.minLength(11)]),
      dataNascimento: new FormControl({ value: null }, [Validators.required]),
      endereco: new FormControl(null),
      cep: new FormControl(null),
      assunto: null,
      descricaoLgpd: new FormControl(null, [Validators.required]),
      // listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      assuntos: [],
      representanteLegal: new FormGroup({
        nome: new FormControl(null),
        cpf: new FormControl(null),
        dataNascimento: new FormControl(null),
        email: new FormControl(null),
      }),
      demanda: new FormControl({ value: null }, [Validators.required]),
      retorno: new FormControl({ value: null }, [Validators.required]),
      requerente: new FormControl({ value: null }, [Validators.required]),
      numeroProcessoSEI: new FormControl(null),
      demandaRecebida: new FormControl(null)
    } as LgpdVO;
  }
}
